var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.path !== '/game/index')?_c('el-page-header',{staticClass:"head-back",on:{"back":_vm.goBack}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"game-header",style:({ backgroundImage: 'url(' + _vm.img + ')' })})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-383bfe11","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/game/head.vue
// module id = null
// module chunks = 